import axios from 'axios';

export default {
  fetchAccounts(params){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/v1/admin/accounts", {params})
      .then(results=>{
        return results.data;
      })
  },
  resetPassword(accountId){
    return axios.put(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+`/API/v1/admin/accounts/${accountId}/password`)
      .then(results=>{
        return results.data;
      })
  },
  createAccount(accountInfo){
    return axios.post(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+`/API/v1/admin/accounts`, accountInfo)
      .then(results=>{
        return results.data;
      })
  },
}
